import classes from './style.module.scss';
import Nav from '../Nav/Nav';
import NavDrawer from '../NavDrawer/NavDrawer';
import React, { useState } from 'react';
import Menu from '../Menu/Menu';
import Plan from '../Plan/Plan';
import News from '../News/News';
import Main from '../Main/Main';
import { Route, Routes } from 'react-router-dom';
import Contacts from '../Contacts/Contacts';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import Promo from '../Promo/Promo';
import Tournaments from '../Tournaments/Tournaments';
import { CartContext } from '../../Context/CartContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
    const [navSwitcher, setNavSwitcher] = useState(false);
    // const [products, setProducts] = useState([]);
    const showNavbar = () => {
        setNavSwitcher(!navSwitcher);
        navSwitcher ? enableBodyScroll(document) : disableBodyScroll(document);
    };

    const onChangeCartButton = (cartArray) => {
        setCart([...cartArray]);
        localStorage.setItem('cart', JSON.stringify(cartArray));
    };

    const cartInit = () => {
        if (localStorage.getItem('cart')) {
            return JSON.parse(localStorage.getItem('cart'));
        } else {
            return [];
        }
    };

    const [cart, setCart] = useState(cartInit);

    return (
        <CartContext.Provider
            value={{
                cart,
                onChangeCartButton,
            }}
        >
            <React.Fragment>
                <div className={classes.container}>
                    <Nav onClick={showNavbar} />
                    <NavDrawer onClick={showNavbar} opened={navSwitcher} />
                    <Routes>
                        <Route path="/" element={<Main />} />
                        <Route path="/menu" element={<Menu />} />
                        <Route path="/news" element={<News />} />
                        {/*<Route*/}
                        {/*    path="/shop"*/}
                        {/*    element={*/}
                        {/*        <Shop*/}
                        {/*            products={products}*/}
                        {/*            setProducts={setProducts}*/}
                        {/*        />*/}
                        {/*    }*/}
                        {/*/>*/}
                        <Route path="/plan" element={<Plan />} />
                        <Route path="/contacts" element={<Contacts />} />
                        <Route path="/promo" element={<Promo />} />
                        <Route path="/tournaments" element={<Tournaments />} />
                        {/*<Route*/}
                        {/*    path="/product/:id"*/}
                        {/*    element={*/}
                        {/*        <ProductPage*/}
                        {/*            onChangeCartButton={onChangeCartButton}*/}
                        {/*            cart={cart}*/}
                        {/*            products={products}*/}
                        {/*        />*/}
                        {/*    }*/}
                        {/*/>*/}
                    </Routes>
                </div>
                <ToastContainer />
            </React.Fragment>
        </CartContext.Provider>
    );
}

export default App;
